import { render, staticRenderFns } from "./breadcrumb-markup.vue?vue&type=template&id=2cad1090&"
import script from "./breadcrumb-markup.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-markup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports